import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/tiktok',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-tiktok" */ '~/pages/TikTok/index')
    ),
  },
] as RouteConfig[]
